export const getResponsiveStyles = (theme, screenSize, isRTL) => {
  const { isMobile, isTablet, isLargeDesktop } = screenSize;

  const dark = theme === "dark";

  return {
    container: { marginTop: 0 },

    mainContent: {
      maxWidth: isLargeDesktop ? "1400px" : "1200px",
      margin: "0 auto",
      padding: isMobile ? "16px 0" : isTablet ? "24px 0" : "32px 0",
      position: "relative",
      zIndex: 1,
      marginTop: "-5%",
    },

    profileHeader: {
      background: dark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      padding: isMobile ? "14px" : isTablet ? "18px 20px" : "20px 24px",
      borderRadius: "14px",
      transition: "all 0.3s ease",
      boxShadow: dark ? "0 4px 16px rgba(0,0,0,0.18)" : "0 4px 16px rgba(0,0,0,0.06)",
      WebkitBackdropFilter: dark ? "blur(25px) saturate(180%)" : "blur(10px)",
      border: dark ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.06)",
      marginBottom: isMobile ? "12px" : isTablet ? "16px" : "20px",
    },

    profileHeaderContent: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "14px" : "20px",
      position: "relative",
      zIndex: 2,
      flexDirection: "row",
      textAlign: "start",
    },

    profileAvatarLarge: {
      width: isMobile ? "64px" : isTablet ? "80px" : "88px",
      height: isMobile ? "64px" : isTablet ? "80px" : "88px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #3b82f6, #0bb856ff)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontSize: isMobile ? "22px" : isTablet ? "28px" : "30px",
      fontWeight: "700",
      border: dark ? "3px solid rgba(255,255,255,0.14)" : "3px solid #ffffff",
      boxShadow: "0 4px 14px rgba(2,95,246,0.18)",
      position: "relative",
      flexShrink: 0,
    },

    avatarEditBtn: {
      position: "absolute",
      bottom: "-2px",
      [isRTL ? "left" : "right"]: "-2px",
      background: "#ffffff",
      border: dark ? "2px solid #1f2738" : "2px solid #e2e8f0",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      borderRadius: "50%",
      width: isMobile ? "26px" : "30px",
      height: isMobile ? "26px" : "30px",
      minWidth: 0,
      minHeight: 0,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#1e293b",
      transition: "all 0.3s ease",
    },

    profileInfo: { flex: 1, minWidth: 0 },

    profileName: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "18px" : isTablet ? "21px" : "24px",
      fontWeight: "700",
      margin: "0 0 4px 0",
      lineHeight: 1.25,
      textAlign: "start",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    profileTitle: {
      color: "#2e7cba",
      fontSize: isMobile ? "13.5px" : isTablet ? "14px" : "15px",
      fontWeight: "600",
      margin: "0 0 2px 0",
      lineHeight: 1.4,
      textAlign: "start",
    },

    profileDepartment: {
      color: dark ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      fontSize: isMobile ? "13px" : "14px",
      margin: 0,
      lineHeight: 1.4,
      textAlign: "start",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    contentGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr" : "2fr 1fr",
      gap: isMobile ? "16px" : isTablet ? "20px" : "32px",
      alignItems: "start",
    },

    card: {
      background: dark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      WebkitBackdropFilter: dark ? "blur(25px) saturate(180%)" : "blur(10px)",
      border: dark ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
      borderRadius: isMobile ? "14px" : "16px",
      padding: isMobile ? "14px" : isTablet ? "20px" : "24px",
      boxShadow: dark ? "0 4px 16px rgba(0,0,0,0.14)" : "0 4px 16px rgba(0,0,0,0.05)",
      marginBottom: isMobile ? "12px" : "20px",
      transition: "all 0.3s ease",
      direction: isRTL ? "rtl" : "ltr",
    },

    cardTitle: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: "600",
      margin: isMobile ? "0 0 14px 0" : "0 0 20px 0",
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "8px" : "12px",
    },

    infoGrid: { display: "grid", gap: isMobile ? "8px" : "12px" },

    infoItem: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "12px" : "14px",
      padding: isMobile ? "10px 12px" : "14px 16px",
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
      flexDirection: "row",
      textAlign: "start",
    },

    infoIcon: {
      width: isMobile ? "34px" : "40px",
      height: isMobile ? "34px" : "40px",
      background: "rgba(59,130,246,0.2)",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#60a5fa",
      flexShrink: 0,
    },

    infoContent: {
      flex: 1,
      minWidth: 0,
      textAlign: "start",
      overflowWrap: "anywhere",
    },

    infoLabel: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: isMobile ? "11.5px" : "12px",
      margin: "0 0 2px 0",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    infoValue: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: "15px",
      fontWeight: "500",
      margin: 0,
      wordWrap: "break-word",
    },

    skillsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(100px, 1fr))"
        : "repeat(auto-fit, minmax(120px, 1fr))",
      gap: "12px",
      marginTop: "16px",
    },

    skillTag: {
      background: "rgba(59,130,246,0.2)",
      color: "#60a5fa",
      padding: isMobile ? "6px 10px" : "8px 12px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "500",
      textAlign: "center",
      border: "1px solid rgba(59,130,246,0.3)",
    },

    statsGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: isMobile ? "12px" : "20px",
      marginBottom: isMobile ? "16px" : "24px",
    },

    statCard: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: isMobile ? "12px" : "16px",
      padding: isMobile ? "16px" : "24px",
      textAlign: "center",
      transition: "all 0.3s ease",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
    },

    statIcon: { margin: "0 auto 12px", display: "block" },

    statValue: {
      color: dark ? "white" : "#1a1a1a",
      fontSize: isMobile ? "24px" : "28px",
      fontWeight: "700",
      margin: "8px 0 4px 0",
    },

    statLabel: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: "13px",
      margin: 0,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    progressBar: {
      background: dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
      borderRadius: "10px",
      height: isMobile ? "6px" : "8px",
      overflow: "hidden",
      marginTop: "8px",
    },

    progressFill: { height: "100%", borderRadius: "10px", transition: "width 0.6s ease" },

    achievementGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(auto-fit, minmax(200px, 1fr))",
      gap: isMobile ? "12px" : "16px",
      marginTop: "16px",
    },

    achievementCard: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      padding: isMobile ? "16px" : "20px",
      textAlign: "center",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
    },

    achievementIcon: { margin: "0 auto 12px", display: "block", color: "#fbbf24" },
    achievementTitle: { color: dark ? "white" : "#1a1a1a", fontSize: "14px", fontWeight: "600", margin: "0 0 4px 0" },
    achievementDate: { color: dark ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)", fontSize: "12px", margin: 0 },

    singleColumn: { gridColumn: "1 / -1" },

    twoColumn: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: isMobile ? "16px" : "24px",
    },

    threeColumn: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(auto-fit, minmax(250px, 1fr))",
      gap: isMobile ? "12px" : "20px",
    },

    projectItem: {
      background: dark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
      borderRadius: "12px",
      padding: isMobile ? "16px" : "20px",
      border: dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.05)",
      marginBottom: "16px",
    },

    projectHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "8px" : "0",
    },

    projectName: { color: dark ? "white" : "#1a1a1a", fontSize: "16px", fontWeight: "600", margin: 0 },

    projectStatus: { padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "500" },

    projectTech: {
      color: dark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      fontSize: "14px",
      margin: 0,
      textAlign: isRTL ? "right" : "left",
    },

    activityItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: isMobile ? "12px" : "16px",
      padding: isMobile ? "12px" : "16px",
      background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)",
      borderRadius: "12px",
      marginBottom: "12px",
      border: dark ? "1px solid rgba(255,255,255,0.05)" : "1px solid rgba(0,0,0,0.03)",
    },

    activityIcon: {
      width: isMobile ? "32px" : "40px",
      height: isMobile ? "32px" : "40px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },

    activityContent: { flex: 1, minWidth: 0, textAlign: isRTL ? "right" : "left" },
    activityText: { color: dark ? "white" : "#1a1a1a", fontSize: isMobile ? "13px" : "14px", fontWeight: "500", margin: "0 0 4px 0" },
    activityTime: { color: dark ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)", fontSize: "12px", margin: 0 },
  };
};

export const getHoverStyles = (theme) => ({
  transform: "translateY(-5px)",
  boxShadow: theme === "dark" ? "0 12px 40px rgba(0,0,0,0.4)" : "0 12px 40px rgba(0,0,0,0.15)",
  background: theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.95)",
  border: theme === "dark" ? "1px solid rgba(255,255,255,0.2)" : "1px solid rgba(0,0,0,0.05)",
  WebkitBackdropFilter: theme === "dark" ? "blur(30px) saturate(200%)" : "blur(15px)",
});

export const getDefaultStyles = (theme) => ({
  transform: "translateY(0) scale(1)",
  boxShadow: theme === "dark" ? "0 8px 32px rgba(0,0,0,0.3)" : "0 8px 32px rgba(0,0,0,0.1)",
  background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
  border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
  WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
});